/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import { LocaleContext } from "../../context/LocaleContext";
import { styLangSelectorWrapper } from "./styles";

const LangSelector = () => {
  const { lang, setLang } = useContext(LocaleContext);

  const handleChangeLang = () => {
    switch (lang) {
      case "id":
        setLang("en");
        break;
      default:
        setLang("id");
        break;
    }
  };

  return (
    <div css={styLangSelectorWrapper} onClick={handleChangeLang}>
      <div>{lang === "en" ? "id" : "en"}</div>
    </div>
  );
};

export default LangSelector;
